import * as Sentry from '@sentry/react';

export const initSentry = () => {
  if (process.env.REACT_APP_SENTRY_DSN && process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.NODE_ENV || 'development',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event, hint) {
        if (event.exception) {
          console.error('Error captured by Sentry:', hint.originalException || hint.syntheticException);
        }
        return event;
      },
      ignoreErrors: [
        'Network request failed',
        'Failed to fetch',
        'NetworkError',
        'Load failed',
        'AbortError',
        'Non-Error promise rejection',
      ],
    });

    console.log('✓ Sentry initialized');
  } else {
    console.log('ℹ Sentry disabled (no DSN or not in production)');
  }
};

export const captureException = (error: Error, context?: Record<string, any>) => {
  Sentry.captureException(error, {
    extra: context,
  });
};

export const captureMessage = (
  message: string,
  level: Sentry.SeverityLevel = 'info',
  context?: Record<string, any>
) => {
  Sentry.captureMessage(message, {
    level,
    extra: context,
  });
};

export const setUser = (user: { id: number; email: string; role: string } | null) => {
  if (user) {
    Sentry.setUser({
      id: user.id.toString(),
      email: user.email,
      role: user.role,
    });
  } else {
    Sentry.setUser(null);
  }
};

export default Sentry;
